// ShiftSettingsForm — manager-only: cash tolerance, manager e-mail (handover + discrepancy), 06:00 night report.
import React, { useEffect, useState } from 'react';
import { Settings, Loader2 } from 'lucide-react';
import { apiCall } from './_shared';

export const ShiftSettingsForm = ({ onSaved }) => {
  const [form, setForm] = useState(null);
  const [msg, setMsg] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => { apiCall('/api/admin/shifts/settings').then(setForm).catch((e) => setMsg(e.message)); }, []);
  if (!form) return <div className="text-xs text-slate-500 flex items-center gap-2"><Loader2 className="w-3 h-3 animate-spin" /> Loading settings…</div>;
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const save = async () => {
    setBusy(true); setMsg('');
    try {
      const body = { tolerance_eur: Number(form.tolerance_eur), manager_email: form.manager_email || null, night_report_enabled: !!form.night_report_enabled, night_report_recipient: form.night_report_recipient || null };
      const r = await apiCall('/api/admin/shifts/settings', { method: 'PUT', body: JSON.stringify(body) });
      setForm(r); setMsg('Saved'); onSaved?.(r);
    } catch (e) { setMsg(e.message); } finally { setBusy(false); }
  };
  return (
    <div className="border rounded-xl p-3 bg-slate-50 space-y-3 text-sm" data-testid="shift-settings">
      <div className="flex items-center gap-2 font-semibold text-slate-800"><Settings className="w-4 h-4" /> Shift settings</div>
      <div className="grid sm:grid-cols-2 gap-3">
        <label className="block">Cash tolerance (€) — bigger differences alert the manager
          <input type="number" step="0.5" min="0" max="500" value={form.tolerance_eur} onChange={(e) => set('tolerance_eur', e.target.value)} className="mt-1 border rounded-lg px-3 py-2 w-full bg-white" data-testid="shift-settings-tolerance" />
        </label>
        <label className="block">Manager e-mail (handover report + cash alerts)
          <input type="email" value={form.manager_email || ''} onChange={(e) => set('manager_email', e.target.value)} placeholder="manager@…" className="mt-1 border rounded-lg px-3 py-2 w-full bg-white" data-testid="shift-settings-manager-email" />
        </label>
        <label className="flex items-center gap-2 mt-1">
          <input type="checkbox" checked={!!form.night_report_enabled} onChange={(e) => set('night_report_enabled', e.target.checked)} data-testid="shift-settings-night-toggle" />
          Send the night report automatically at 06:00
        </label>
        <label className="block">Night report recipient (blank = manager e-mail)
          <input type="email" value={form.night_report_recipient || ''} onChange={(e) => set('night_report_recipient', e.target.value)} placeholder="owner@…" className="mt-1 border rounded-lg px-3 py-2 w-full bg-white" data-testid="shift-settings-night-recipient" />
        </label>
      </div>
      <div className="flex items-center gap-3">
        <button type="button" onClick={save} disabled={busy} className="bg-slate-900 text-white rounded-lg px-4 py-2 text-sm font-semibold disabled:opacity-60" data-testid="shift-settings-save">{busy ? 'Saving…' : 'Save settings'}</button>
        {msg && <span className={`text-xs ${msg === 'Saved' ? 'text-emerald-700' : 'text-red-700'}`} data-testid="shift-settings-msg">{msg}</span>}
        {form.updated_by && <span className="text-xs text-slate-500">last saved by {form.updated_by}</span>}
      </div>
    </div>
  );
};

export default ShiftSettingsForm;
